import { useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import styles from './SupplyTargetingIcons.module.scss';

export const SupplyTargetingIcons = ({ supplyTargeting }) => {
    const { [supplyTargeting?.iconsKey]: iconsNames } = useCommonConfig([supplyTargeting?.iconsKey] || []);
    const { [supplyTargeting?.moreIconsKey]: moreIcons } = useCommonConfig([supplyTargeting?.moreIconsKey] || []);

    if (!iconsNames) {
        return null;
    }
    const icons = iconsNames?.split(',') || [];

    return (
        <div className={styles['iconsContainer']}>
            {icons.map((icon, index) => (
                <div key={index} className={styles['iconWrapper']}>
                    <img
                        src={`https://www.google.com/s2/favicons?sz=32&domain_url=https://www.${icon}.com`}
                        alt="Logo"
                        className={styles['icon']}
                    />
                </div>
            ))}
            {moreIcons && <span className={styles['more-icons']}>{`+${moreIcons} more`}</span>}
        </div>
    );
};
